import { lazy } from 'app/lazy'
import { LazyLoad } from 'features/common/ui/LazyLoad'
import ClientContext from 'features/common/ui/ClientContext'
import { Client } from 'features/common/utils/clientParameter'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'
import BuilderLoginPrompt from './BuilderPublic/BuilderLoginPrompt'

const BuilderPrivate = lazy(() => import('./BuilderPrivate/BuilderPrivate'))
const BuilderPublic = lazy(() => import('./BuilderPublic/BuilderPublic'))
const ViewerWrapper = lazy(() => import('./BuilderPublic/ViewerWrapper'))
const CustomBuilderMapNotFoundError = lazy(() => import('features/errors/ui/CustomBuilderMapNotFoundError'))

const routes = [
  {
    path: 'builder',
    element: <ClientContext client={Client.Builder} />,
    children: [
      {
        index: true,
        element: (
          <LazyLoad>
            <AuthenticatedRoute element={<BuilderPrivate />} />
          </LazyLoad>
        )
      },
      {
        path: ':mapId',
        element: (
          <LazyLoad>
            <AuthenticatedRoute element={<BuilderPrivate />} prompt={<BuilderLoginPrompt />} />
          </LazyLoad>
        )
      }
    ]
  },
  {
    path: 'builder/error/404',
    element: (
      <LazyLoad>
        <CustomBuilderMapNotFoundError />
      </LazyLoad>
    )
  },
  {
    //  This route to public 'map/**' */ is managed by infra in the specific firebase & CSP configuration
    //  Double check if a change in the path is needed
    path: 'map',
    element: <ClientContext client={Client.Builder} />,
    children: [
      {
        path: ':mapId',
        element: (
          <LazyLoad>
            <BuilderPublic />
          </LazyLoad>
        )
      }
    ]
  },
  {
    path: 'viewer/:mapId',
    element: (
      <LazyLoad>
        <ViewerWrapper />
      </LazyLoad>
    )
  }
]
export default routes
